import { config as workerConfig } from '../config/worker';
import { useRoles } from './useRoles';

const allowedRoles = ['cars-writer', 'cars-coordinator', 'project-owner', 'admin', 'super-admin'];

export function useCanAccessWeekPlanner() {
  const { roles, isAuthenticated } = useRoles(workerConfig);
  let hasRole = false;
  hasRole = (roles && roles.some((r) => allowedRoles.includes(r))) ?? false;

  return { canAccessWeekPlanner: hasRole, isAuthenticated };
}
